/* jslint browser: true */
/* global document window */
import React, { Component } from 'react';
import axios from 'axios';
import validator from 'validator';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { apiUrl } from '../lib/constants.js';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            login: '', // contient le nom d'utilisateur (si coté admin) ou l'email de l'utilisateur (coté non admin)
            pass: '', // contient le mot de passe
            error: '' // contient un message d'erreur qui est affiché sous les inputs
        };
        this.handleChangeForm = this.handleChangeForm.bind(this);
        this.handleSubmitLogin = this.handleSubmitLogin.bind(this);
        this.handleSubmitResetPassword = this.handleSubmitResetPassword.bind(
            this
        );
        if (this.props.location.search === '?c') {
            toast.warn(
                'Erreur 401: Vous devez être connecté ou autorisé pour accéder à cette page'
            );
        } else if (this.props.location.search === '?o') {
            toast.success('Le mot de passe a bien été modifié.');
        } else if (this.props.location.search === '?h') {
            toast.error("Le lien n'est plus valide.");
        } else if (this.props.location.search === '?a') {
            toast.error(
                'Votre compte a été désactivé, merci de contacter Lucia Rapetti.'
            );
        }
    }

    componentWillMount() {}

    /**
     * Affecte les valeurs des input du formulaire au State
     */
    handleChangeForm() {
        this.setState({
            login: document.querySelector('#email').value,
            pass: document.querySelector('#password').value
        });
    }

    /**
     * Récupère et envoie les données du formulaire, si l'on est sur le formulaire de la page admin (this.props.admin === true),
     * la requete est dirigé vers la route admin et vis versa
     * @param  {Event} e - Evenement du click
     */
    handleSubmitLogin(e) {
        e.preventDefault();
        this.handleChangeForm();
        if (!validator.isEmail(this.state.login) && !this.props.admin) {
            toast.error('Email invalide');
            return;
        }
        if (validator.isEmpty(this.state.pass)) {
            toast.error('Saisir un mot de passe');
            return;
        }
        if (!this.props.admin) {
            axios
                .post(`${apiUrl}/api/v1/login`, {
                    login: this.state.login,
                    pass: this.state.pass
                })
                .then(response => {
                    this.setState({ error: '' });
                    if (response.data.token !== '') {
                        window.localStorage.setItem(
                            'token',
                            response.data.token
                        );
                        axios.defaults.headers.common.Authorization = window.localStorage.getItem(
                            'token'
                        );
                        window.location.href = '/programme';
                    } else {
                        this.setState({
                            error: 'Email ou mot de passe incorrect'
                        });
                    }
                })
                .catch(() => {});
        } else {
            axios
                .post(`${apiUrl}/api/v1/login/admin`, {
                    login: this.state.login,
                    pass: this.state.pass
                })
                .then(response => {
                    this.setState({ error: '' });
                    if (response.data.token !== '') {
                        window.localStorage.setItem(
                            'token',
                            response.data.token
                        );
                        axios.defaults.headers.common.Authorization = window.localStorage.getItem(
                            'token'
                        );
                        window.location.href = '/admin/pro';
                    } else {
                        this.setState({
                            error: 'Email ou mot de passe incorrect'
                        });
                    }
                })
                .catch(() => {});
        }
    }

    /**
     * Récupère et envoie les données du formulaire
     * @param  {Event} e - Evenement du click
     */
    handleSubmitResetPassword(e) {
        e.preventDefault();
        this.handleChangeForm();
        if (!validator.isEmail(this.state.login)) {
            toast.error('Séléctionnez une adresse mail valide');
            return;
        }
        axios
            .post(`${apiUrl}/api/v1/login/lost`, { email: this.state.login })
            .then(() => {
                toast.success('Email de réinitialisation envoyé !');
                this.setState({ error: '' });
            })
            .catch(() => {});
    }

    render() {
        return (
            <div
                className="login-wrapper"
                style={{
                    backgroundImage: !this.props.admin
                        ? 'url(/pictures/home-background.jpg)'
                        : 'url(/pictures/admin-background.jpg)'
                }}
            >
                <form>
                    <div>
                        {this.props.admin ? (
                            <label className="full-width" htmlFor="email">
                                Nom d&apos;utilisateur
                                <br />
                                <input
                                    required
                                    style={{ marginTop: '8px' }}
                                    className="text-center"
                                    type="text"
                                    name="email"
                                    id="email"
                                    onChange={() => this.handleChangeForm()}
                                />
                            </label>
                        ) : (
                            <label className="full-width" htmlFor="email">
                                E-mail
                                <br />
                                <input
                                    required
                                    style={{ marginTop: '8px' }}
                                    className="text-center"
                                    type="email"
                                    name="email"
                                    id="email"
                                    onChange={() => this.handleChangeForm()}
                                />
                            </label>
                        )}
                    </div>
                    <div style={{ marginTop: '15px' }}>
                        <label className="full-width" htmlFor="password">
                            Mot de passe
                            <br />
                            <input
                                required
                                style={{ marginTop: '8px' }}
                                className="text-center"
                                type="password"
                                name="password"
                                id="password"
                                onChange={() => this.handleChangeForm()}
                            />
                        </label>
                    </div>
                    <div
                        className={
                            this.state.error === ''
                                ? 'fadeOut errors'
                                : 'fadeIn errors'
                        }
                    >
                        <p>{this.state.error}</p>
                    </div>
                    <div>
                        <button
                            className="btn myBtn"
                            onClick={e => this.handleSubmitLogin(e)}
                        >
                            Valider
                        </button>
                        {// ajoute de bouton "Mot de passe oublié" si l'utilisateur n'est pas sur la page login Admin
                        this.props.admin === false ? (
                            <button
                                className="btn btn-link"
                                onClick={e => this.handleSubmitResetPassword(e)}
                            >
                                Mot de passe oublié
                            </button>
                        ) : (
                            <br />
                        )}
                    </div>
                </form>
            </div>
        );
    }
}

// Declaration des props du composant
Login.propTypes = { admin: PropTypes.bool };
// Définition par defaut (si non-attribué a l'appel du composant) des props
Login.defaultProps = { admin: false };

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js